module.exports = __webpack_public_path__ + "img/interface-screen-5.e5b6104.jpg";